import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss']
})
export class ConfigurationComponent implements OnInit {
  
	bgTextColor = "#000000";
  environment = environment

  constructor() { }

  ngOnInit() {
    this.onInit();
  }

  onInit(): void {
    if (localStorage.getItem('bgTextColor')) this.bgTextColor = localStorage.getItem("bgTextColor");
  }

}
